export default __webpack_public_path__ + "static/media/bot-logo.5ef38f5a.svg";